import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useState } from 'react';
export var useImageListState = function useImageListState() {
  var _useState = useState({
      description: '',
      uploadList: [],
      successList: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setImageListState = function setImageListState(data) {
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), data);
    });
  };
  return [state, setImageListState];
};
export var useDialogState = function useDialogState() {
  var _useState3 = useState({
      selectedImages: [],
      imageListDialogVisible: false,
      cropDialogVisible: false,
      uploadStatusModalStatus: 'hide'
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var setDialogState = function setDialogState(data) {
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), data);
    });
  };
  return [state, setDialogState];
};
export var useCropResultList = function useCropResultList() {
  var _useState5 = useState({
      selectedIndex: 0,
      result: []
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    state = _useState6[0],
    setState = _useState6[1];
  var setCropState = function setCropState(data) {
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), data);
    });
  };
  return [state, setCropState];
};